import React from 'react';
import AllAppsInternalPage from '../../features/apps/components/AllAppsInternalPage';

/** Hidden internal catalogue at /all-apps — not linked in nav. */
const AllAppsInternalRoute = () => <AllAppsInternalPage />;

export default AllAppsInternalRoute;
